import React from "react";
import { useSelector } from "react-redux";
import { useAppSelector } from "../../../../../hooks";
import { IssueDashboardOptionsEnum } from "../../issueConstants";
import { selectIssueBoard } from "../../issueSelectors";
import BreeamDashboard from "./BreeamDashboard";
import IssueStandardDashboard from "./IssueStandardDashboard";
import RisikoDashboard from "./Risiko/RisikoDashboard";

const IssueDashboardMain: React.FC<{ projectId: string; issueBoardId: string }> = ({ projectId, issueBoardId }) => {
  const activeDashboardInRedux = useAppSelector((state) => state.issueReducerNew.activeDashboard);
  const issueBoard = useSelector(selectIssueBoard);

  const activeDashboard = activeDashboardInRedux != null ? activeDashboardInRedux : issueBoard?.dashboardSetting;

  return (
    <>
      <div className="d-flex flex-column w-100 overflow-auto mx-1">
        {activeDashboard === IssueDashboardOptionsEnum.STANDARD && <IssueStandardDashboard />}
        {activeDashboard === IssueDashboardOptionsEnum.BREEAM && (
          <BreeamDashboard projectId={projectId} issueBoard={issueBoard} />
        )}
        {activeDashboard === IssueDashboardOptionsEnum.BREEAM_PREANALYSE && <p>Hello BREEAM preanalyse-dashboard</p>}
        {activeDashboard === IssueDashboardOptionsEnum.RISIKO && <RisikoDashboard />}
      </div>
    </>
  );
};

export default IssueDashboardMain;
